module.exports = __webpack_public_path__ + "static/media/clicker_icon.84180342.png";